module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-magazine-4b74a61435cc18daa017c21cc2e927d6.png";